import React from 'react'
import './about.css'
const About = () => {
  return (
    <section className="about section-padding" id="about">
      <div className="container">
        <div className="grid">
          <div className="about-img">
            <div className="img-box"data-aos="zoom-in" data-aos-duration="1000" >
              <img src="img/about-img.png" alt="About Niks Elite Cleaning - Professional cleaning team serving Melbourne western suburbs" loading="lazy"/>
              <div className="box box-1" style={{color:"black"}}>
                <span>1.5k</span>
                <p>satisfied clients</p>
              </div>
            </div>
          </div>
          <div className="about-text">
            <div className="section-title">
              <span className="title" data-aos="fade-up" data-aos-duration="600">about us</span>
              <h2 className="sub-title" data-aos="fade-up" data-aos-duration="600">Trusted Cleaning Experts Serving Melbourne's Western Suburbs Since 2021</h2>
            </div>
            <p data-aos="fade-up" data-aos-duration="600">At Niks Elite Cleaning, we don't just clean—we care. Since 2021, we've been transforming homes and workspaces with spotless precision and a personal touch. With over 1,500+ happy clients across Melbourne's western suburbs, our reputation is built on reliability, attention to detail, and a passion for excellence.</p>
            <p data-aos="fade-up" data-aos-duration="600">
              <strong>Serving 8 Locations:</strong> We're proud to provide professional cleaning services across <strong>Sunshine VIC 3020, Werribee VIC 3030, Melbourne VIC 3004, Parkville VIC 3052, Truganina VIC 3029, Point Cook VIC 3030, Hoppers Crossing VIC 3029, and Williams Landing VIC 3027</strong>. No matter which suburb you're in, our team is ready to deliver elite cleaning results.
            </p>
            <p data-aos="fade-up" data-aos-duration="600">
              We specialise in residential cleaning, regular house cleaning, deep cleaning, end of lease cleaning, move-in and move-out cleaning, and professional office cleaning services. Whether you need weekly maintenance, a one-time deep clean, or a customised cleaning plan for your kitchen, bathrooms, bedrooms, and living areas, our trained professionals are ready to help.
            </p>
            <p data-aos="fade-up" data-aos-duration="600">
              Our fully vetted and experienced local cleaners use professional-grade equipment and eco-friendly cleaning products to ensure your home or workspace is not only spotless but also safe for your family, pets, and employees. From vacuuming and mopping to detailed dusting and disinfecting high-touch surfaces, we handle every detail with precision and care.
            </p>
            <p data-aos="fade-up" data-aos-duration="600">
              From sparkling kitchens to sanitised offices, we make sure your space isn’t just clean — it’s elite clean. Because when it comes to cleanliness, good enough isn’t enough — you deserve extraordinary.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About